import { Injectable } from '@angular/core';

/**
 * Lightweight confirmation abstraction for user decisions.
 * Keeps feature code testable and allows replacement with a shared modal later.
 *
 * @author sadatmalik
 */
@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  confirm(message: string): boolean {
    return window.confirm(message);
  }
}
